import React, { useEffect } from "react";
import Logo from "../../../assets/images/CareSMS_Logo.png";
import {
  useGoogleAuthMutation,
  useMicrosoftAuthMutation,
  useVerifyEmailMutation,
} from "../../../features/auth/authApiSlice";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import CalendarCheckSvg from "../../../assets/svgs/CalendarCheckSvg";
import LocationSvg from "../../../assets/svgs/LocationSvg";
import { ArrowRight } from "@mui/icons-material";

const Auth = ({ option, step, handleStepChange, email, setEmail }) => {
  const [errMsg, setErrMsg] = React.useState(null);

  const [verifyEmail, { isLoading }] = useVerifyEmailMutation();
  const [googleAuth] = useGoogleAuthMutation();
  const [microsoftAuth] = useMicrosoftAuthMutation();
  const navigate = useNavigate();
  const handleEmailAuth = async () => {
    try {
      await verifyEmail({
        email: email,
        path: option,
        provider: "Email",
      }).unwrap();

      handleStepChange(step + 1);
    } catch (error) {
      if (!error.status) setErrMsg("No response from server");
      else if (error.status === 400 || error.status === 404)
        setErrMsg(error.data.message);
      else setErrMsg("An error occurred. Please try again.");
    }
  };

  const handleGoogleAuth = async () => {
    try {
      // const google_user = await googleAuth().unwrap();
      window.open(`${process.env.REACT_APP_BACKEND_URL}/auth/google`, "_self");
      // console.log(google_user, "google_user");
      // handleStepChange(step + 1);
    } catch (error) {
      if (!error.status) setErrMsg("No response from server");
      else if (error.status === 400 || error.status === 404)
        setErrMsg(error.data.message);
      else setErrMsg("An error occurred. Please try again.");
    }
  };

  const handleMicrosoftAuth = async () => {
    try {
      window.open(`${process.env.REACT_APP_BACKEND_URL}/auth/microsoft`, "_self");
    } catch (error) {
      if (!error.status) setErrMsg("No response from server");
      else if (error.status === 400 || error.status === 404)
        setErrMsg(error.data.message);
      else setErrMsg("An error occurred. Please try again.");
    }
  };

  useEffect(() => {
    setErrMsg(null);
  }, [email]);

  return (
    <div className="relative flex flex-col gap-4 w-full h-[calc(100vh-20px)]">
      <div className="flex flex-col w-full h-full">
        <div className="justify-between pb-4 w-full d-flex">
          <img src={Logo} alt="logo" className="logo" />
          {/* <button
            className={classNames(
              "py-2 font-semibold rounded-lg transition-all px-8",
              option === "signup"
                ? "border-[0.5px] border-black text-black"
                : "border-[0.5px] border-primaryblue text-primaryblue"
            )}
            onClick={() =>
              navigate(option === "signup" ? "/signin" : "/signup")
            }
          >
            Sign {option === "signup" ? "in" : "up"}
          </button> */}

          {option === "signup" && (
            <button
              className={classNames(
                "py-2 font-semibold rounded-lg transition-all px-8",
                "border-[0.5px] border-black text-black"
              )}
              onClick={() => navigate("/signin")}
            >
              Sign in
            </button>
          )}
        </div>
        <div className="flex flex-col justify-between h-screen max-w-fit">
          <div className="flex flex-col gap-8 w-full">
            <div className="flex flex-col gap-2 items-start">
              <h1 className="m-0 text-4xl font-bold">
                {option === "signup"
                  ? "Create your CareSMS account "
                  : "Sign in"}
              </h1>
              <h2
                className={classNames(
                  option === "signup"
                    ? "text-primaryorange text-base font-bold"
                    : "text-primarytextgrey text-lg"
                )}
              >
                {option === "signup"
                  ? "Sign up to begin your 30-day free trial today"
                  : "Streamline home-based care delivery with CareSMS"}
              </h2>
            </div>
            <div className="flex flex-col gap-4">
              <div className="flex flex-row gap-2 items-center">
                <CalendarCheckSvg />
                <p className="m-0 text-lg font-bold">
                  Instantly create daily visit schedules for each Provider
                </p>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <LocationSvg />
                <p className="m-0 text-lg font-bold">
                  Automatically optimize for routing and visit clustering
                </p>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <LocationSvg />
                <p className="m-0 text-lg font-bold">
                  Manage visit rules for each Patient or Community
                </p>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <LocationSvg />
                <p className="m-0 text-lg font-bold">
                  Build and share key reports across your Practice
                </p>
              </div>
              <div className="flex flex-row gap-2 items-center">
                <LocationSvg />
                <p className="m-0 text-lg font-bold">
                  Improve your quality of patient care delivery
                </p>
              </div>
            </div>
            <div className="flex flex-col justify-center grow">
              <div className="gap-4 justify-center items-center py-2 pt-4 d-flex flex-column sm:pt-5">
                {/* Microsoft SSO Button */}
                <button
                  onClick={handleMicrosoftAuth}
                  className="flex justify-center items-center gap-2 py-2 w-full text-lg text-white rounded-md bg-[#2F2F2F] hover:bg-[#1a1a1a] transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="21"
                    viewBox="0 0 21 21"
                  >
                    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                  </svg>
                  {option === "signup"
                    ? "Sign up with Microsoft"
                    : "Sign in with Microsoft"}
                </button>
                <span className="text-sm font-bold text-gray-400">OR</span>
                {/* Google SSO Button */}
                {/* <button
                  onClick={handleGoogleAuth}
                  className="flex justify-center items-center gap-2 py-2 w-full text-lg text-gray-700 rounded-md bg-white border border-gray-300 hover:bg-gray-50 transition-colors"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 48 48"
                  >
                    <path
                      fill="#FFC107"
                      d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"
                    />
                    <path
                      fill="#FF3D00"
                      d="M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"
                    />
                    <path
                      fill="#4CAF50"
                      d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z"
                    />
                    <path
                      fill="#1976D2"
                      d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"
                    />
                  </svg>
                  {option === "signup"
                    ? "Sign up with Google"
                    : "Sign in with Google"}
                </button> */}
                {/* <span className="text-sm font-bold text-gray-400">OR</span> */}
                {/* Email Sign In Button */}
                <button
                  onClick={() => handleStepChange(step + 1)}
                  className="flex justify-center items-center py-2 w-full text-lg text-black rounded-md bg-primarylightgrey hover:bg-gray-200 transition-colors"
                >
                  {option === "signup"
                    ? "Sign Up with Email"
                    : "Sign In with Email"}
                  <ArrowRight />
                </button>
              </div>
            </div>
          </div>
          <p className="text-sm text-center">
            {new Date().getFullYear()} CareSMS Inc. All rights reserved.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Auth;
